module.exports = __webpack_public_path__ + "static/media/phone_icon.b0a2368f.svg";